/* eslint-disable no-restricted-globals */
import React from 'react';
import { Formik } from 'formik';
import Loading from 'components/common/loading/Loading';
import { useQuery } from 'react-query';
import { NewMacroSC } from './NewMacro.style';
import { validationSchema, editInitialValues } from 'components/kb/utils';
import NewMacroStep1 from './new-macro-step-1/NewMacroStep1';
import NewMacroStep2 from './new-macro-step-2/NewMacroStep2';
import NewMacroStep3 from './new-macro-step-3/NewMacroStep3';
import NewMacroStep5 from './new-macro-step-5/NewMacroStep5';
import NewMacroStep4 from './new-macro-step-4/NewMacroStep4';

const EditNewMacro = () => {
  let macroId = location?.hash?.split('macros/')[1];
  const { data: ticketDepartment } = useQuery('/admin/tickets/departments');
  const { data: ticketDepName } = useQuery('/admin/tickets/department/definitions');
  const { data, isLoading } = useQuery(`/admin/kb/macros/${macroId}`);

  return isLoading ? (
    <Loading />
  ) : (
    <Formik initialValues={editInitialValues(data)} validationSchema={validationSchema}>
      {(formikProp) => (
        <NewMacroSC>
          <NewMacroStep1 formikProp={formikProp} edited={true} />
          <NewMacroStep2
            formikProp={formikProp}
            edited={true}
            ticketDepartment={ticketDepartment}
            ticketDepName={ticketDepName}
          />
          <NewMacroStep3 formikProp={formikProp} edited={true} />
          <NewMacroStep4 formikProp={formikProp} edited={true} />
          <NewMacroStep5 formikProp={formikProp} loadingCreateMacro={false} edited={true} />
        </NewMacroSC>
      )}
    </Formik>
  );
};
export default EditNewMacro;
